// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
    padding: 10px 0;
}

/* Pour éviter que le header soit collé au bord */
.page {
    padding: 20px;
}


.notes-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 20px;
}

.note-card2 {
    background: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.08);
}

.note-card2 .preview,
.note-card2 p {
    white-space: pre-wrap;
}

.note-content2 {
    white-space: pre-wrap;
    line-height: 1.6;
    font-size: 1rem;
    margin-bottom: 20px;
}

.author {
    font-size: 0.85rem;
    opacity: 0.7;
    margin-bottom: 8px;
}

.note-header2 {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 15px;
}

.note-title {
    margin: 0;
    font-size: 1.4rem;
    font-weight: 600;
}

.note-meta {
    text-align: right;
}

.note-author {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 500;
    background: rgba(0,0,0,0.05);
    padding: 4px 8px;
    border-radius: 6px;
}

.note-card2-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px; /* évite que ça colle */
}

/* Le titre ne doit PAS prendre toute la place */
.note-card2-title {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 600;
    white-space: nowrap;        /* pas de retour à la ligne */
    overflow: hidden;           /* cache le texte trop long */
    text-overflow: ellipsis;    /* ajoute "..." */
    max-width: 70%;             /* laisse de la place à l'auteur */
}

/* L'auteur reste toujours à droite, sur une seule ligne */
.note-card2-author {
    margin: 0;
    font-size: 0.85rem;
    opacity: 0.7;
    white-space: nowrap;        /* jamais de retour à la ligne */
    text-align: right;
}



.note-date {
    margin: 0;
    font-size: 0.8rem;
    opacity: 0.6;
}




.dashboard.dark .note-card2 {
    background: #2f3136;
}

.note-card2 h3 {
    margin: 0 0 10px 0;
}

.note-card2 .preview {
    opacity: 0.8;
    margin-bottom: 15px;
}

.note-actions2 {
    display: flex;
    gap: 10px;
}

.small-btn {
    padding: 6px 10px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    background: #6fb8af;
    color: white;
}

.small-btn.delete {
    background: #d9534f;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Notes.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA,iDAAiD;AACjD;IACI,aAAa;AACjB;;;AAGA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS,EAAE,uBAAuB;AACtC;;AAEA,gDAAgD;AAChD;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB,SAAS,6BAA6B;IACzD,gBAAgB,YAAY,6BAA6B;IACzD,uBAAuB,KAAK,iBAAiB;IAC7C,cAAc,cAAc,kCAAkC;AAClE;;AAEA,0DAA0D;AAC1D;IACI,SAAS;IACT,kBAAkB;IAClB,YAAY;IACZ,mBAAmB,SAAS,gCAAgC;IAC5D,iBAAiB;AACrB;;;;AAIA;IACI,SAAS;IACT,iBAAiB;IACjB,YAAY;AAChB;;;;;AAKA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".page-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 25px;\r\n    padding: 10px 0;\r\n}\r\n\r\n/* Pour éviter que le header soit collé au bord */\r\n.page {\r\n    padding: 20px;\r\n}\r\n\r\n\r\n.notes-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\r\n    gap: 20px;\r\n}\r\n\r\n.note-card2 {\r\n    background: white;\r\n    padding: 20px;\r\n    border-radius: 12px;\r\n    box-shadow: 0 2px 6px rgba(0,0,0,0.08);\r\n}\r\n\r\n.note-card2 .preview,\r\n.note-card2 p {\r\n    white-space: pre-wrap;\r\n}\r\n\r\n.note-content2 {\r\n    white-space: pre-wrap;\r\n    line-height: 1.6;\r\n    font-size: 1rem;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.author {\r\n    font-size: 0.85rem;\r\n    opacity: 0.7;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.note-header2 {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.note-title {\r\n    margin: 0;\r\n    font-size: 1.4rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.note-meta {\r\n    text-align: right;\r\n}\r\n\r\n.note-author {\r\n    margin: 0;\r\n    font-size: 0.95rem;\r\n    font-weight: 500;\r\n    background: rgba(0,0,0,0.05);\r\n    padding: 4px 8px;\r\n    border-radius: 6px;\r\n}\r\n\r\n.note-card2-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 10px; /* évite que ça colle */\r\n}\r\n\r\n/* Le titre ne doit PAS prendre toute la place */\r\n.note-card2-title {\r\n    margin: 0;\r\n    font-size: 1.1rem;\r\n    font-weight: 600;\r\n    white-space: nowrap;        /* pas de retour à la ligne */\r\n    overflow: hidden;           /* cache le texte trop long */\r\n    text-overflow: ellipsis;    /* ajoute \"...\" */\r\n    max-width: 70%;             /* laisse de la place à l'auteur */\r\n}\r\n\r\n/* L'auteur reste toujours à droite, sur une seule ligne */\r\n.note-card2-author {\r\n    margin: 0;\r\n    font-size: 0.85rem;\r\n    opacity: 0.7;\r\n    white-space: nowrap;        /* jamais de retour à la ligne */\r\n    text-align: right;\r\n}\r\n\r\n\r\n\r\n.note-date {\r\n    margin: 0;\r\n    font-size: 0.8rem;\r\n    opacity: 0.6;\r\n}\r\n\r\n\r\n\r\n\r\n.dashboard.dark .note-card2 {\r\n    background: #2f3136;\r\n}\r\n\r\n.note-card2 h3 {\r\n    margin: 0 0 10px 0;\r\n}\r\n\r\n.note-card2 .preview {\r\n    opacity: 0.8;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.note-actions2 {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.small-btn {\r\n    padding: 6px 10px;\r\n    border-radius: 6px;\r\n    border: none;\r\n    cursor: pointer;\r\n    background: #6fb8af;\r\n    color: white;\r\n}\r\n\r\n.small-btn.delete {\r\n    background: #d9534f;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
